export const environment = {
  production: true,
  url: "https://interna.piki7.com/api-backend",
  // url: "http://localhost:8003/api",
  // url: "https://interna.piki7.com/api-test-backend",
  // url: "http://165.227.80.88:8003/api",
  ms_booking: "https://interna.piki7.com/api-booking",
  // ms_booking: "http://localhost:9007/api",
  ms_parking: "https://interna.piki7.com/api-parking",
  ms_transaction: "https://interna.piki7.com/api-storage",
  // ms_transaction: "http://localhost:9009/api",
};
